import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";
 
@Injectable({
    providedIn: "root"
})
export class NavigationService {
  private appHistory: string[] = [];
 
  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.appHistory.push(event.urlAfterRedirects);
      }
    });
  }
 
  back(): void {
    if (this.appHistory.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl("/");
    }
    this.appHistory.pop();
  }
}